(() => {
  const root = document.getElementById('AvivaConcierge');
  if (!root) return;

  const launcher = root.querySelector('.aviva-concierge__launcher');
  const dialog = root.querySelector('.aviva-concierge__dialog');
  const close = root.querySelector('[data-concierge-close]');
  const form = root.querySelector('form');
  const input = root.querySelector('textarea');
  const messages = root.querySelector('.aviva-concierge__messages');
  const whatsapp = root.dataset.whatsapp || 'https://wa.me/918595300801';
  const whatsappLabel = root.dataset.whatsappLabel || '+91 8595300801';

  const knowledge = [
    {
      keys: ['cleanser', 'face wash', 'gentle'],
      answer:
        'Our Daily Gentle Cleanser is a water-based face wash that cleans without stripping moisture. Customers love how fresh and soft skin feels after every use.'
    },
    {
      keys: ['toner', 'creme skin', 'pore'],
      answer:
        'Aviva Creme Skin Toner supports a simple face-care ritual after cleansing. Pair it with the Daily Gentle Cleanser for best results.'
    },
    {
      keys: ['lotion', 'body', 'roll'],
      answer:
        'The Hydrating Body Lotion (roll-on) feels lightweight and non-sticky — ideal for everyday body care and humid Indian weather.'
    },
    {
      keys: ['sunscreen', 'spf', 'sun'],
      answer:
        'Aviva Aqua Gel Sunscreen is our everyday sun-care option. Apply as the last step of your morning face ritual.'
    },
    {
      keys: ['gift', 'hamper', 'combo'],
      answer:
        'We offer gift hampers and combos (for example cleanser + toner, or cleanser + sunscreen). Browse Shop or Gift Sets for current bundles.'
    },
    {
      keys: ['ship', 'delivery', 'cod', 'order'],
      answer:
        'We ship across India. For live shipping timelines, COD availability, or order tracking, please WhatsApp us and our team will help.'
    },
    {
      keys: ['return', 'refund', 'exchange'],
      answer:
        'Returns and exchanges follow our store refund policy. Message us on WhatsApp with your order details and we will guide you.'
    },
    {
      keys: ['vegan', 'paraben', 'mineral', 'cruelty', 'tested'],
      answer:
        'Aviva Beauty products are positioned as mineral-oil free, paraben free, vegan, and dermatologically tested.'
    },
    {
      keys: ['about', 'founder', 'vanshika', 'brand'],
      answer:
        'Aviva Beauty was founded by Vanshika Chachra. We focus on simple, rejuvenating skincare that nurtures both skin and spirit.'
    },
    {
      keys: ['hi', 'hello', 'hey', 'help'],
      answer:
        'Hi! I can help with Aviva cleansers, toners, body lotion, sunscreen, gifts, and store policies. What would you like to know?'
    }
  ];

  const sessionKey = 'aviva_concierge_session';
  const sessionId =
    sessionStorage.getItem(sessionKey) ||
    (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
  sessionStorage.setItem(sessionKey, sessionId);

  const add = (text, kind = 'assistant', asHtml = false) => {
    const p = document.createElement('p');
    p.className = kind;
    if (asHtml) p.innerHTML = text;
    else p.textContent = text;
    messages.append(p);
    messages.scrollTop = messages.scrollHeight;
    return p;
  };

  const whatsappHtml = () =>
    `I don’t have a confident answer for that. Please connect with us on <a href="${whatsapp}" target="_blank" rel="noopener">WhatsApp ${whatsappLabel}</a> for resolving your queries.`;

  const localAnswer = (message) => {
    const q = String(message || '').toLowerCase();
    if (/(pregnan|rash|burning|swelling|diagnos|medical|doctor)/i.test(q)) {
      return `I can share product information only — not medical advice. For pregnancy, irritation, or medical concerns, please consult a dermatologist. For store help, WhatsApp ${whatsappLabel}.`;
    }
    let best = null;
    let score = 0;
    knowledge.forEach((item) => {
      const hits = item.keys.reduce((sum, key) => sum + (q.includes(key) ? 1 : 0), 0);
      if (hits > score) {
        score = hits;
        best = item.answer;
      }
    });
    return score > 0 ? best : null;
  };

  const open = () => {
    dialog.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    input.focus();
  };

  const shut = () => {
    dialog.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  };

  launcher.addEventListener('click', () => {
    if (dialog.hidden) open();
    else shut();
  });
  close.addEventListener('click', shut);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) shut();
  });

  async function send(message) {
    const text = String(message || '').trim();
    if (!text) return;
    add(text, 'visitor');
    input.value = '';
    const pending = add('Consulting the Aviva archive…', 'assistant');

    const endpoint = (root.dataset.endpoint || '').replace(/\/$/, '');
    const canCallApi = endpoint && !endpoint.includes('YOUR-PROXY') && /^https?:\/\//i.test(endpoint);

    if (!canCallApi) {
      pending.remove();
      const local = localAnswer(text);
      if (local) add(local, 'assistant');
      else add(whatsappHtml(), 'assistant', true);
      return;
    }

    try {
      const response = await fetch(`${endpoint}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          sessionId,
          message: text,
          pageContext: {
            productTitle: root.dataset.productTitle,
            productUrl: root.dataset.productUrl,
            productDescription: root.dataset.productDescription
          }
        })
      });
      const data = await response.json().catch(() => ({}));
      pending.remove();

      if (!response.ok || data.escalate || data.fallbackWhatsapp || !data.answer) {
        const local = localAnswer(text);
        if (local) add(local, 'assistant');
        else add(whatsappHtml(), 'assistant', true);
        return;
      }

      add(data.answer, 'assistant');
    } catch (error) {
      pending.remove();
      const local = localAnswer(text);
      if (local) add(local, 'assistant');
      else add(whatsappHtml(), 'error', true);
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    send(input.value);
  });

  root.querySelectorAll('[data-concierge-prompt]').forEach((button) => {
    button.addEventListener('click', () => send(button.textContent));
  });
})();
